if (!customElements.get('frolsi-slideshow')) {
  customElements.define('frolsi-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-go-to]')];
      this.index = 0;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1, true), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true), options));
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.show(index);
      }, options);
      this.show(0);
      const controls = this.querySelector('[data-controls]');
      if (controls) controls.hidden = false;
    }
    disconnectedCallback() { this.controller?.abort(); }
    show(index, announce = false) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; });
      this.dots.forEach((dot, position) => dot.setAttribute('aria-pressed', String(position === this.index)));
      const status = this.querySelector('[data-slide-status]');
      if (announce && status) status.textContent = `Slide ${this.index + 1} di ${this.slides.length}`;
    }
  });
}
